import { Injectable, inject } from '@angular/core';

import { Actions, createEffect, ofType } from '@ngrx/effects';
import { map, switchMap } from 'rxjs/operators';

import { MapsApiService, catchAppError } from '@core/api';

import { limitsActions } from '../actions/limits.actions';

@Injectable()
export class LimitsEffects {
  private actions$ = inject(Actions);
  private mapsApi = inject(MapsApiService);

  checkMapsLimits$ = createEffect(() =>
    this.actions$.pipe(
      ofType(limitsActions.fetchMapsBalance),
      switchMap(() =>
        this.mapsApi.balance().pipe(
          map((data) => limitsActions.fetchMapsBalanceSuccess({ data })),
          catchAppError((error) => limitsActions.fetchMapsBalanceFail({ error }))
        )
      )
    )
  );
}
